import { useState, useEffect } from 'react';
import { FormControl, Stack, FormLabel, Text, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import DatePicker from '@/components/forms/new/formikFormFields/DatePicker';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import { FORM_FIELD_PATHS } from '../../constants';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from '@/components/forms/new/formStyles';

const TrialExpiryDatePicker = ({ errors, darkMode }) => {
    const { formData, updateFormData } = useCompanyForm();

    const [date, setDate] = useState(new Date(formData?.trialEndLocal));

    useEffect(() => {
        if (!formData?.trialEnd) {
            setDate({
                trialEnd: Date.now(),
            });
        }
    }, [formData?.trialEnd]);

    const handleChange = (_, v) => {
        const newDate = new Date(v);
        newDate.setHours(0, 0, 0, 0);
        updateFormData(FORM_FIELD_PATHS.TRIAL_END, newDate);
        setDate(newDate);
    };

    const [isHovered, setIsHovered] = useState(false);
    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors?.[FORM_FIELD_PATHS.TRIAL_END]}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={stackStyling(true)}>
                <Box>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Trial Expiry
                    </FormLabel>
                    <Text sx={descriptionStyling} maxWidth={250}>
                        Date Format is yyyy/MM/dd
                    </Text>
                </Box>
                <Field
                    component={DatePicker}
                    id={FORM_FIELD_PATHS.TRIAL_END}
                    name={FORM_FIELD_PATHS.TRIAL_END}
                    darkMode={darkMode}
                    date={date}
                    valueHandler={FORM_FIELD_PATHS.TRIAL_END}
                    dateFormat="yyyy/MM/dd"
                    changeHandler={handleChange}
                    validate={() => {
                        if (
                            !formData[FORM_FIELD_PATHS.TRIAL_END] ||
                            formData[FORM_FIELD_PATHS.TRIAL_END] === ''
                        ) {
                            return 'Trial Expiry is required';
                        }
                        const trialEndDate = new Date(
                            formData[FORM_FIELD_PATHS.TRIAL_END],
                        );
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);
                        if (trialEndDate < today) {
                            return 'Trial Expiry date must be in the future';
                        }
                    }}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Select Trial Expiry date"
                        ariaLabel="entity-trial-expiration-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default TrialExpiryDatePicker;
